import {
    FaGift, FaFire, FaCalendarAlt, FaUsers, FaUserFriends, FaClock,
    FaSun, FaCrown, FaCommentDollar, FaHeart, FaStar, FaPlane,
    FaUmbrellaBeach, FaCar, FaHotel, FaMapMarkerAlt, FaGlobeAmericas,
    FaMountain, FaCity,
    FaQuestionCircle, FaLightbulb, FaExclamationCircle,
    FaCheckCircle, FaInfoCircle, FaShieldAlt, FaRocket
} from 'react-icons/fa';

export const IconLibrary = [
    FaGift,
    FaFire,
    FaCalendarAlt,
    FaUsers,
    FaUserFriends,
    FaClock,
    FaSun,
    FaCrown,
    FaCommentDollar,
    FaHeart,
    FaStar,
    FaPlane,
    FaUmbrellaBeach,
    FaCar,
    FaHotel,
    FaMapMarkerAlt,
    FaGlobeAmericas,
    FaMountain,
    FaCity,
    FaQuestionCircle,
    FaLightbulb,
    FaExclamationCircle,
    FaCheckCircle,
    FaInfoCircle,
    FaShieldAlt,
    FaRocket
];

export const IconLibraryWithLabels = IconLibrary.map((icon, index) => ({
    icon,
    label: [
        'Подарок', 'Распродажа', 'Срок', 'Группа', 'Друзья', 'Время',
        'Лето', 'VIP', 'Деньги', 'Любовь', 'Топ', 'Путешествие', 'Пляж',
        'Авто', 'Отель', 'Место', 'Мир', 'Природа', 'Город',
        'Вопрос', 'Помощь', 'Идея', 'Важно', 'Подтверждение',
        'Информация', 'Безопасность', 'Быстро'
    ][index]
}));
